import { apiClient } from './client';

export interface RecognitionDto {
  recognitionId: number;
  recipientName: string;
  brgId: number;
  brgName: string;
  eventId: number | null;
  eventTitle: string;
  recognitionTypeId: number;
  recognitionTypeLabel: string;
  pointsSnapshot: number;
  dollarValueSnapshot: number;
  anticipatedAwardDate: string;
  reason: string;
  description?: string;
  submittedBy: number;
  submittedByName: string;
  submittedAt: string;
  recognitionStatusId: number;
  approvedBy?: number;
  approvedAt?: string;
  deniedBy?: number;
  deniedAt?: string;
  mmRecognitionId?: number;
}

export interface RecognitionTypeDto {
  recognitionTypeId: number;
  typeKey: string;
  label: string;
  exampleActions?: string;
  points: number;
  dollarValue: number;
  displayOrder: number;
  isActive: boolean;
  backgroundColor?: string;
  textColor?: string;
}

export interface RecognitionStatsDto {
  totalYtd: number;
  approvedCount: number;
  pendingCount: number;
  deniedCount: number;
  approvalRatePercent: number;
  denialRatePercent: number;
}

export interface SubmitRecognitionRequest {
  RecipientName: string;
  BrgId: number;
  EventId: number;
  RecognitionTypeId: number;
  AnticipatedAwardDate: string;
  Reason: string;
  Description?: string;
}

export const recognitionsApi = {
  list(filters?: { brgId?: number; status?: string; recognitionTypeId?: number }): Promise<RecognitionDto[]> {
    const params = new URLSearchParams();
    if (filters?.brgId) params.append('brgId', filters.brgId.toString());
    if (filters?.status) params.append('status', filters.status);
    if (filters?.recognitionTypeId) params.append('recognitionTypeId', filters.recognitionTypeId.toString());
    
    const queryString = params.toString();
    const path = `/api/recognitions${queryString ? '?' + queryString : ''}`;
    return apiClient.get<{ items: RecognitionDto[] }>(path).then(r => r.items || []);
  },

  getById(id: number): Promise<RecognitionDto> {
    return apiClient.get<RecognitionDto>(`/api/recognitions/${id}`);
  },

  getStats(): Promise<RecognitionStatsDto> {
    return apiClient.get<RecognitionStatsDto>('/api/recognitions/stats');
  },

  getTypes(): Promise<RecognitionTypeDto[]> {
    return apiClient.get<{ items: RecognitionTypeDto[] }>('/api/recognitions/types').then(r => r.items || []);
  },

  submit(data: SubmitRecognitionRequest): Promise<RecognitionDto> {
    return apiClient.post<RecognitionDto>('/api/recognitions', data);
  },

  approve(id: number): Promise<void> {
    return apiClient.post<void>(`/api/recognitions/${id}/approve`, {});
  },

  deny(id: number, reason?: string): Promise<void> {
    return apiClient.post<void>(`/api/recognitions/${id}/deny`, { reason });
  },
};
